/** Days after the period ended before the Pulse banner turns red (GRA-60). */
export const PULSE_OVERDUE_DAYS = 3;
const MS_PER_DAY = 24 * 60 * 60 * 1000;

/** Whole days since the period ended, 0 on the first day of the new period. */
export function daysSincePeriodEnd(
  periodEnd: string,
  now: Date = new Date(),
): number {
  const endMs = Date.parse(`${periodEnd}T00:00:00.000Z`);
  if (Number.isNaN(endMs)) return 0;
  return Math.max(0, Math.floor((now.getTime() - endMs) / MS_PER_DAY));
}
